<template>
  <div v-if="isVisible" class="update-modal-overlay">
    <div class="update-modal">
             <div class="update-modal-header">
         <h3>🔄 بروزرسانی جدید</h3>
       </div>
      
      <div class="update-modal-content">
        <div class="update-info">
          <div class="version-info">
            <span class="new-version">نسخه جدید: {{ newVersion }}</span>
          </div>
          
          <div class="update-description">
            <h4>تغییرات جدید:</h4>
            <ul class="update-changes">
              <li v-for="(change, index) in updateChanges" :key="index">
                {{ change }}
              </li>
            </ul>
          </div>
          
         
        </div>
        
       
        
        <div class="update-success" v-if="isUpdated">
          <div class="success-icon">
            <i class="fa-solid fa-check-circle"></i>
          </div>
          <h4>بروزرسانی با موفقیت انجام شد!</h4>
          <p>نسخه جدید اپلیکیشن آماده استفاده است.</p>
          <button @click="closeModal" class="close-btn">
            <i class="fa-solid fa-times"></i>
            بستن
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UpdateModal',
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    currentVersion: {
      type: String,
      default: ''
    },
    newVersion: {
      type: String,
      default: ''
    },
    updateChanges: {
      type: Array,
      default: () => []
    },
    isUpdated: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
    performUpdate() {
      this.$emit('update');
    }
  }
}
</script>

<style scoped>
.update-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10001;
  backdrop-filter: blur(5px);
}

.update-modal {
  background-color: #1a1a1a;
  border-radius: 15px;
  padding: 25px;
  max-width: 90vw;
  width: 500px;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.5);
  border: 2px solid #6153cc;
}

.update-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 2px solid #333;
}

.update-modal-header h3 {
  color: #fff;
  margin: 0;
  font-size: 22px;
  font-weight: bold;
  font-family: IRANSansWeb;
}



.update-modal-content {
  color: #fff;
}

.update-info {
  margin-bottom: 25px;
}

.version-info {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  padding: 15px;
  background-color: #2a2a2a;
  border-radius: 10px;
  border: 1px solid #444;
}

.current-version, .new-version {
  font-size: 16px;
  font-weight: bold;
  font-family: IRANSansWeb;
}

.current-version {
  color: #888;
}

.new-version {
  color: #4CAF50;
}

.update-description h4 {
  color: #fff;
  margin-bottom: 15px;
  font-size: 18px;
  font-weight: bold;
  font-family: IRANSansWeb;
}

.update-changes {
  list-style: none;
  padding: 0;
  margin: 0;
}

.update-changes li {
  padding: 8px 0;
  padding-right: 20px;
  position: relative;
  font-size: 14px;
  line-height: 1.6;
  font-family: IRANSansWeb;
}

.update-changes li:before {
  content: "✓";
  color: #4CAF50;
  font-weight: bold;
  position: absolute;
  right: 0;
  top: 8px;
}

.update-note {
  background-color: #2a2a2a;
  padding: 15px;
  border-radius: 10px;
  border-left: 4px solid #ff9800;
  margin-top: 20px;
}

.update-note p {
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
  font-family: IRANSansWeb;
  color: #ffd700;
}

.update-actions {
  text-align: center;
}

.update-btn {
  background: linear-gradient(135deg, #6153cc 0%, #fd7691 100%);
  color: white;
  border: none;
  padding: 15px 30px;
  border-radius: 25px;
  font-size: 16px;
  font-weight: bold;
  font-family: IRANSansWeb;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(97, 83, 204, 0.3);
}

.update-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(97, 83, 204, 0.4);
}

.update-btn i {
  margin-left: 8px;
}

.update-success {
  text-align: center;
  padding: 20px 0;
}

.success-icon {
  margin-bottom: 20px;
}

.success-icon i {
  font-size: 60px;
  color: #4CAF50;
  animation: successPulse 2s infinite;
}

.update-success h4 {
  color: #4CAF50;
  font-size: 20px;
  font-weight: bold;
  font-family: IRANSansWeb;
  margin-bottom: 15px;
}

.update-success p {
  color: #fff;
  font-size: 16px;
  font-family: IRANSansWeb;
  margin-bottom: 25px;
  line-height: 1.5;
}

.close-btn {
  background: linear-gradient(135deg, #4CAF50 0%, #45a049 100%);
  color: white;
  border: none;
  padding: 12px 25px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: bold;
  font-family: IRANSansWeb;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(76, 175, 80, 0.3);
}

.close-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(76, 175, 80, 0.4);
}

.close-btn i {
  margin-left: 8px;
}

@keyframes successPulse {
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.8;
  }
}

@media (max-width: 768px) {
  .update-modal {
    margin: 20px;
    padding: 20px;
  }
  
  .version-info {
    flex-direction: column;
    gap: 10px;
  }
  
  .update-changes li {
    font-size: 13px;
  }
}
</style>
